import React, { useState, useRef, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import LeadModal from './LeadModal';
import './Products.css';

const products = [
  {
    id: 1,
    title: 'Пульты управления',
    description: 'Пульты управления для систем автоматизации, распределения и контроля. Изготавливаются цельносварными из стали толщиной 1,5 мм или из нержавеющей стали AISI 304. Доступны в моноблочном и модульном исполнении, с одной или двумя дверями. Степень защиты IP54–IP66.',
    price: 'Цена: от 13 000 ₽',
    image: '/images/product-1.webp'
  },
  {
    id: 2,
    title: 'Изготовление корпусов по индивидуальным чертежам',
    description: 'Изготавливаем корпуса любой сложности по вашим чертежам или ТЗ. Помогаем доработать конструкцию, подобрать материал. Работаем от 1 штуки до серии.',
    price: 'Цена: индивидуально, от 1 шт.',
    image: '/images/product-2.webp'
  },
  {
    id: 3,
    title: 'Оболочки из нержавеющей стали с повышенной герметичностью',
    description: 'Шкафы из нержавеющей стали AISI 304 для агрессивных сред. Повышенная герметичность защищает оборудование от влаги, пыли и химикатов. Степень защиты IP66, EXe, EXd.',
    price: 'Цена: от 55 000 ₽',
    image: '/images/product-3.webp'
  },
  {
    id: 4,
    title: 'Классические компактные настенные распределительные шкафы',
    description: 'Настенные шкафы для размещения аппаратуры, клеммных колодок и ПЛК. Изготовлены из стали 1,5–2,0 мм или нержавейки AISI 304. Степень защиты IP55–IP66, IK10.',
    price: 'Цена: от 11 000 ₽',
    image: '/images/product-4.webp'
  },
  {
    id: 5,
    title: 'Мелкие распределительные коробки, клеммные боксы и сигнальные шкафчики',
    description: 'Компактные корпуса для монтажа клеммников, реле и сигнального оборудования. Материал: сталь 1,2–1,5 мм или нержавейка AISI 304. Степень защиты IP54–IP66.',
    price: 'Цена: от 5 000 ₽',
    image: '/images/product-5.webp'
  },
  {
    id: 6,
    title: 'Специальные корпуса скругленной формы с наклонной крышей',
    description: 'Гигиенические корпуса для пищевых и фармацевтических производств. Скругленная форма и наклон крыши 30° исключают скопление загрязнений. Силиконовое уплотнение, стойкое к моющим средствам. Степень защиты IP55–IP66.',
    price: 'Цена: от 9 000 ₽',
    image: '/images/product-6.webp'
  },
  {
    id: 7,
    title: 'Напольные однодверные и двухдверные шкафы рамной конструкции',
    description: 'Универсальные напольные шкафы для систем управления и распределения электроэнергии. Рамная конструкция обеспечивает жесткость и надежность. Двухдверные исполнения для широкого оборудования.',
    price: 'Цена: от 84 000 ₽ (однодверные), от 105 000 ₽ (двухдверные)',
    image: '/images/product-7.webp'
  }
];

// Mirrors the .product-card flex-basis breakpoints in Products.css.
const getPerView = () => (window.innerWidth <= 576 ? 1 : window.innerWidth <= 992 ? 2 : 4);

const Products = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [perView, setPerView] = useState(getPerView);
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const scrollRef = useRef(null);
  const maxIndex = Math.max(0, products.length - perView);

  useEffect(() => {
    const onResize = () => setPerView(getPerView());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    setCurrentIndex((i) => Math.min(i, maxIndex));
  }, [maxIndex]);

  useEffect(() => {
    const track = scrollRef.current;
    if (!track) return;
    track.scrollTo({ left: currentIndex * (track.scrollWidth / products.length), behavior: 'smooth' });
  }, [currentIndex]);

  const next = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const prev = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  return (
    <section id="products" className="products-section">
      <div className="container-custom">
        <div className="products-slider">
          <button className="slider-arrow slider-arrow-left" onClick={prev} disabled={currentIndex <= 0}>
            <FaChevronLeft />
          </button>
          
          <div className="products-track" ref={scrollRef}>
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-image-wrapper">
                  <img src={product.image} alt={product.title} className="product-image" />
                </div>
                <div className="product-info">
                  <h3 className="product-title">{product.title}</h3>
                  <div className="product-description">
                    <p>{product.description}</p>
                    <p className="product-price">{product.price}</p>
                  </div>
                  <button type="button" className="product-btn" onClick={() => setIsLeadModalOpen(true)}>
                    Получить КП
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button className="slider-arrow slider-arrow-right" onClick={next} disabled={currentIndex >= maxIndex}>
            <FaChevronRight />
          </button>
        </div>
      </div>
      <LeadModal show={isLeadModalOpen} onClose={() => setIsLeadModalOpen(false)} goalId="form-kp" />
    </section>
  );
};

export default Products;
